import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation',
  templateUrl: './covid-confirmation.component.html',
  styleUrls: ['./covid-confirmation.component.scss']
})
export class CovidConfirmationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
